import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = (pathname: string) => {
    const titles: { [key: string]: { title: string; subtitle?: string } } = {
      '/dashboard': { 
        title: 'Dashboard', 
        subtitle: 'Overview and analytics' 
      },
      '/parts': { 
        title: 'Parts Inventory', 
        subtitle: 'Manage vehicle parts and stock levels' 
      },
      '/categories': { 
        title: 'Categories', 
        subtitle: 'Organize parts by categories' 
      },
      '/locations': { 
        title: 'Locations', 
        subtitle: 'Manage storage locations and warehouses' 
      },
      '/suppliers': { 
        title: 'Suppliers', 
        subtitle: 'Vendor and supplier management' 
      },
      '/movements': { 
        title: 'Stock Movements', 
        subtitle: 'Track inventory transactions' 
      },
      '/settings': { 
        title: 'Settings', 
        subtitle: 'System configuration and preferences' 
      }
    };

    return titles[pathname] || { 
      title: 'VTMS', 
      subtitle: 'Vehicle Parts Inventory Management System' 
    };
  };

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const { title, subtitle } = getPageTitle(location.pathname);

  return (
    <div className="h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
        currentPath={location.pathname}
        onNavigate={handleNavigate}
        isCollapsed={sidebarCollapsed}
        onCollapseToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col h-screen">
        {/* Header */}
        <Header
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          title={title}
          subtitle={subtitle}
        />

        {/* Page Content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
